/* eslint-disable max-len */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line max-classes-per-file
import React, { Component } from 'react';
import {
  Col, Row, Nav, Navbar, Form, Button, ButtonToolbar, OverlayTrigger, Popover,
} from 'react-bootstrap';
import CryptoAES from 'crypto-js/aes';
import CryptoEnc from 'crypto-js/enc-utf8';
import { Navigate } from 'react-router';
import { RegEditView, RegEditBody, GButton, Spinner, Toolbar} from './RegulationEditor.styles';
import AppContext from '../../AppContext';
import 'Styles/SCSS/ag-theme-material.scss';
import config from '../../config';
import CDATA from 'Services/CDATA';
import EMTv4_Fields from 'assets/EMTv4_Fields.json';

const { encKey } = config.sessionStorage;

class EMTv4editor extends Component {
  emtSections = [];

  constructor(props) {
    super(props);
    this.emtSections = EMTv4_Fields;

    let sessionState = sessionStorage.getItem('PageStateStorage');
    let propsID = this.props.location.classcode_bk;
    if (propsID) {
      this.state = {
        regulation_name: props.location.regulation_name,
        page: window.location.pathname,
        raw_api: this.props.raw_api,
        api_name: this.props.location.api_name,
        loading: false,
        failed: false,
        Class_Code: this.props.location.classcode_bk,
        Fund_Code: this.props.location.fundcode_bk,
        Reference_Language: this.props.location.language,
        eventKey: 'General Info',
        action_type: this.props.location.action_type,
        toolbarButtons: [
          'Placeholder' === 'Edit' ? (
            <GButton
              key={0}
              onClick={() => { this.handleApprove(); }} size="Medium" type="Primary" text="Approve"
            />
          ) : (
            <GButton key={0} onClick={() => { this.handleReject(); }} size="Medium" type="Primary" text="Re-Open" />
          )
        ],
        validated: false,
        loaded: false,
        redirect: false,
      };
      sessionStorage.setItem('PageStateStorage', CryptoAES.encrypt(JSON.stringify(this.state), encKey));
    } else if (sessionState && JSON.parse(CryptoAES.decrypt(sessionState.toString(), encKey).toString(CryptoEnc)).page === window.location.pathname) {
      this.state = JSON.parse(CryptoAES.decrypt(sessionState.toString(), encKey).toString(CryptoEnc));
    } else {
      this.state = { redirect: true };
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  async componentDidMount() {
    const urlParameters = CDATA.addFilter(`ClientCode_bk eq '${this.context.state.selectedClient.code}' and x_00050_General_Reference_Date eq '${this.context.state.selectedReportingDate.code}' and x_00010_Financial_Instrument_Identifying_Data eq '${this.state.Class_Code}'`);
    try {
      const data = await CDATA.makeRequest(
        'GET',
        'PRIIPS_app_EMTv4_OUTPUT',
        urlParameters,
        {},
        'Error retrieving data.'
      );

      let emtFields = data.value[0];
      this.setState(emtFields);
      this.state.emtVersion = this.context.state.emtVersion;
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'We\'re sorry, there was an issue loading this data. Please try again. If the issue persists, contact your administrator.',
      });
    }
  }

  async saveEMTv4(emtSection) {
    let payload = {
      Version: (Number(this.state.Version) + 0.001),
      ClientCode_bk: this.state.Client_Code,
      FundCode_bk: this.state.Fund_Code,
      Status: this.state.Status,
      UpdatedBy: this.props.mail,
      LastUpdated: new Date()
    };

    let fields = this.emtSections.find(x => x.section.indexOf(emtSection)>-1).fields;
    
    fields.forEach(item => {
        payload[`x_${item}`] = this.state[`x_${item}`] === "" ? null : this.state[`x_${item}`];      
    });    
    try {
      const data = await CDATA.makeRequest(
        'PUT',
        'PRIIPS_App_EMTv4/' + this.state.RECORD_ID,
        '',
        payload,
        'EMT saved successfully',
        false
      ).then(() => {        
        this.setState({ redirect: true });
      });
      this.setState({ Version: Number(this.state.Version) + 0.001 });
    } catch (err) {
      this.setState({
        loading: false,
        failed: true,
        failMessage: 'EMT Not Saved. Code: ' + err.response.data.error.code + '\r\nMessage: ' + err.response.data.err.message,
      });
    }
  }

  handleSubmit(event, emtSection) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ validated: true, Status: 'Ready for Review' });
      this.saveEMTv4(emtSection);
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      this.setState({ validated: true, Status: 'Ready for Review' });
      this.saveEMTv4(emtSection);
    }
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
    sessionStorage.setItem('PageStateStorage', CryptoAES.encrypt(JSON.stringify(this.state), encKey));
  }

  handleSelectChange(selectedItems) {
    this.setState({ selectedItems });
  }

  disableValidation() {
    this.setState({ validated: false });
  }

  handleApprove(event) {
    const modalContent = <div><p>Approving {this.state.Class_Code} EMT...</p></div>;
    this.context.handlers.setModal('Approving ...', modalContent, null, null, true);

    CDATA.makeRequest(
      'POST',
      'PRIIPS_App_APPROVE_EMTv4_BULK',
      '',
      {
        ClientCode_bk: this.context.state.selectedClient.code,
        RecordIDList: this.state.RECORD_ID.toString(),
        UserName: this.context.state.userEmail,
      },
      'Approve failed.',
    )
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'You successfully approved the EMT for Portfolio: '}
              <span>{this.state.Class_Code}</span>
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ action_type: 'View', status: 'Approved' });
        this.refreshData();
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to approve the EMT for the Portfolio:'}
              <span> {this.state.Class_Code} </span>
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  handleReject(event) {
    const modalContent = <div><p>Re Opening {this.state.Class_Code} EMT...</p></div>;
    this.context.handlers.setModal('Re Opening ...', modalContent, null, null, true);

    CDATA.makeRequest(
      'POST',
      'PRIIPS_App_REOPEN_EMTv4_BULK',
      '',
      {
        ClientCode_bk: this.context.state.selectedClient.code,
        RecordIDList: this.state.RECORD_ID.toString(),
        UserName: this.context.state.userEmail,
      },
      'Re-Open failed.',
    )
      .then((res) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'success',
          body: (
            <>
              {'EMT re-opened successfully for the Portfolio: '}
              <span>{this.state.Class_Code}</span>
              .
            </>
          ),
        };
        this.context.handlers.setToast(toast);
        this.setState({ action_type: 'Edit', status: 'Ready for review' });
        this.refreshData();
      })
      .catch((error) => {
        this.context.handlers.closeModal();
        const toast = {
          type: 'error',
          body: (
            <>
              {'Error - something went wrong and we were not able to re-open the EMT for the Portfolio'}
              <span> {this.state.Class_Code} </span>
              {' you had selected.'}
            </>
          ),
        };
        this.context.handlers.setToast(toast);
      });
  }

  refreshData() {
    this.setState({ loading: false }, () => this.saveEMTv4());
  }

  render() {
    var path = "/regulatory-reporting/emtv4/dashboard";
    return (
      this.state.redirect === true ? <Navigate to={path} replace /> : (
        <RegEditView>
          <RegEditBody>
            {
              // this.state.failed ? <GrpError text={this.state.failMessage} /> : (
              <>
                <Navbar style={{ backgroundColor: '#e9e8f0' }}>
                  <Nav class="nav nav-tabs" style={{ backgroundColor: '#e9e8f0', marginLeft: -15 }} onSelect={selectedKey => this.setState({ eventKey: selectedKey })} onClick={() => { this.disableValidation(); }}>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="General Info">General Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Investor">Investor</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Risk">Risk</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="Objectives">Objectives</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="CostsExAnte">CostsExAnte</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link style={{ color: '#6F08CD' }} eventKey="CostsExPost">CostsExPost</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Nav className="ml-auto" style={{ marginRight: '40px' }}>
                    {
                      this.state.action_type === 'Edit' ? (
                        <GButton
                          onClick={() => this.handleApprove()}
                          text="Approve"
                          type="Primary"
                          size="Medium"
                        />
                      ) : (
                        <GButton
                          text="Re-open"
                          type="Primary"
                          size="Medium"
                          onClick={() => this.handleReject()}
                        />
                      )
                    }
                  </Nav>
                  <Nav>
                    <Navbar.Collapse className="justify-content-end">
                      <Navbar.Text>
                        {this.state.Class_Code + ' - '}
                        <a style={{ color: '#6F08CD' }}>{this.state.eventKey}</a>
                      </Navbar.Text>
                    </Navbar.Collapse>
                    {
                      this.state.loading ? <Spinner text="Loading data..." /> : (
                        this.gridApi && (
                          <Toolbar
                            api={this.gridApi}
                            working={this.state.toolbarWorking}
                            exportName={this.state.api_name}
                            controls={this.state.toolbarButtons}
                            count={{
                              total: this.state.totalRowCount,
                              showing: this.state.displayedRowCount,
                            }}
                          />
                        )
                      )
                    }
                  </Nav>
                </Navbar>
                <Row style={{ display: 'flex', flexDirection: '1', flexGrow: '1' }} className="no-padding">
                  {
                    this.state.eventKey === 'General Info' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'General')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-00010_Financial_Instrument_Identifying_Data'}
                                  >
                                    Identification of the financial instrument
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00010_Financial_Instrument_Identifying_Data.controlID">
                                  <Form.Label>
                                    00010_Financial_Instrument_Identifying_Data
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#F8F8FF' : '#F8F8FF' }}
                                    name="x_00010_Financial_Instrument_Identifying_Data"
                                    value={this.state.x_00010_Financial_Instrument_Identifying_Data}
                                    onChange={this.handleInputChange}
                                    disabled
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    One of the following options is required in this field: ISIN, CUSIP, SEDOL, WKN , Bloomberg Ticker, BBGID, Reuters RIC, FIGI, LEI, Other code by members of the Association of National Numbering Agencies, Code attributed by the undertaking
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover id={'popover-00020_Type_Of_Identification_Code_For_The_Financial_Instrument'}>
                                    Codification chosen to identify the financial instrument
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00020_Type_Of_Identification_Code_For_The_Financial_Instrument.controlID">
                                  <Form.Label>00020_Type_Of_Identification_Code_For_The_Financial_Instrument</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00020_Type_Of_Identification_Code_For_The_Financial_Instrument"
                                    value={this.state.x_00020_Type_Of_Identification_Code_For_The_Financial_Instrument}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: 1, 2, 3, 4, 5, 6, 7, 8, 9, 99.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover id={'popover-00030_Financial_Instrument_Name'}>
                                    Name of the financial instrument
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00030_Financial_Instrument_Name.controlID">
                                  <Form.Label>00030_Financial_Instrument_Name</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00030_Financial_Instrument_Name"
                                    value={this.state.x_00030_Financial_Instrument_Name}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="255 Character Limit"
                                    maxLength="255"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and cannot be longer than 255 characters.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover id={'popover-00040_Financial_Instrument_Currency'}>
                                    Denomination currency of the financial instrument
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00040_Financial_Instrument_Currency.controlID">
                                  <Form.Label>00040_Financial_Instrument_Currency</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00040_Financial_Instrument_Currency"
                                    value={this.state.x_00040_Financial_Instrument_Currency}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="ISO 4217 Currency Code"
                                    pattern="(AED|AFN|ALL|AMD|ANG|AOA|ARS|AUD|AWG|AZN|BAM|BBD|BDT|BGN|BHD|BIF|BMD|BND|BOB|BOV|BRL|BSD|BTN|BWP|BYN|BZD|CAD|CDF|CHE|CHF|CHW|CLF|CLP|CNY|COP|COU|CRC|CUC|CUP|CVE|CZK|DJF|DKK|DOP|DZD|EGP|ERN|ETB|EUR|FJD|FKP|GBP|GEL|GHS|GIP|GMD|GNF|GTQ|GYD|HKD|HNL|HRK|HTG|HUF|IDR|ILS|INR|IQD|IRR|ISK|JMD|JOD|JPY|KES|KGS|KHR|KMF|KPW|KRW|KWD|KYD|KZT|LAK|LBP|LKR|LRD|LSL|LYD|MAD|MDL|MGA|MKD|MMK|MNT|MOP|MRU[13]|MUR|MVR|MWK|MXN|MXV|MYR|MZN|NAD|NGN|NIO|NOK|NPR|NZD|OMR|PAB|PEN|PGK|PHP|PKR|PLN|PYG|QAR|RON|RSD|RUB|RWF|SAR|SBD|SCR|SDG|SEK|SGD|SHP|SLL|SOS|SRD|SSP|STN[15]|SVC|SYP|SZL|THB|TJS|TMT|TND|TOP|TRY|TTD|TWD|TZS|UAH|UGX|USD|USN|UYI|UYU|UYW|UZS|VES|VND|VUV|WST|XAF|XAG|XAU|XBA|XBB|XBC|XBD|XCD|XDR|XOF|XPD|XPF|XPT|XSU|XTS|XUA|XXX|YER|ZAR|ZMW|ZWL)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be in Currency Code ISO 4217 format.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-00050_General_Reference_Date'}>
                                    Date to which the data refer
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00050_Reference_Date.controlID">
                                  <Form.Label>00050_General_Reference_Date</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#F8F8FF' : '#F8F8FF' }}
                                    name="x_00050_General_Reference_Date"
                                    value={this.state.x_00050_General_Reference_Date}
                                    onChange={this.handleInputChange}
                                    disabled
                                    placeholder="YYYY-MM-DD"
                                    pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a date formatted as YYYY-MM-DD.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>

                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover id={'popover-00060_Financial_Instrument_Product_Type'}>
                                    Structured Securities or Structured Funds or UCITS or Non UCITS
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00060_Financial_Instrument_Product_Type.controlID">
                                  <Form.Label>00060_Financial_Instrument_Product_Type</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00060_Financial_Instrument_Product_Type"
                                    value={this.state.x_00060_Financial_Instrument_Product_Type}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="S / SF / U / N"
                                    pattern="(S|SF|U|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: S,SP,U,N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover id={'popover-00070_Financial_Instrument_Manufacturer_Name'}>
                                    Name of Manufacturer of the financial instrument. The one who is responsible for manufacturing the financial instrument
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00070_Financial_Instrument_Manufacturer_Name.controlID">
                                  <Form.Label>00070_Financial_Instrument_Manufacturer_Name</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00070_Financial_Instrument_Manufacturer_Name"
                                    value={this.state.x_00070_Financial_Instrument_Manufacturer_Name}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover id={'popover-00080_Financial_Instrument_Guarantor_Name'}>
                                    Name of Guarantor of the financial instrument.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00080_Financial_Instrument_Guarantor_Name.controlID">
                                  <Form.Label>00080_Financial_Instrument_Guarantor_Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00080_Financial_Instrument_Guarantor_Name"
                                    value={this.state.x_00080_Financial_Instrument_Guarantor_Name}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover id={'popover-00090_Product_Category_Or_Nature_Germany'}>
                                    Designation of the respective product category or nature
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="00090_Product_Category_Or_Nature_Germany.controlID">
                                  <Form.Label>00090_Product_Category_Or_Nature_Germany</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00090_Product_Category_Or_Nature_Germany"
                                    value={this.state.x_00090_Product_Category_Or_Nature_Germany}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover id={'popover-00100_Leveraged_Financial_Instrument_Or_Contingent_Liability_Instrument'}>
                                    Yes or No
                                  </Popover>
                                )}
                              >
                                <Form.Group
                                  controlId="00100_Leveraged_Financial_Instrument_Or_Contingent_Liability_Instrument.controlID"
                                >
                                  <Form.Label>
                                    00100_Leveraged_Financial_Instrument_Or_Contingent_Liability_Instrument
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_00100_Leveraged_Financial_Instrument_Or_Contingent_Liability_Instrument"
                                    value={this.state.x_00100_Leveraged_Financial_Instrument_Or_Contingent_Liability_Instrument}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N"
                                    pattern="(Y|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y, N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}>Cancel</Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    ) : null
                  }
                  {
                    this.state.eventKey === 'Investor' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'Investor')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-01010_Investor_Type_Retail'}>
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01010_Investor_Type_Retail.controlID">
                                  <Form.Label>01010_Investor_Type_Retail</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01010_Investor_Type_Retail"
                                    value={this.state.x_01010_Investor_Type_Retail}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover id={'popover-01020_Investor_Type_Professional'}>
                                    Yes or No or Neutral or Professional Per Se or Elective Professional or Both
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01020_Investor_Type_Professional.controlID">
                                  <Form.Label>01020_Investor_Type_Professional</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01020_Investor_Type_Professional"
                                    value={this.state.x_01020_Investor_Type_Professional}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral / P / E / B"
                                    pattern="(Y|N|Neutral|P|E|B)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N, Neutral,P,E,B.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-01030_Investor_Type_Eligible_Counterparty'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="01030_Investor_Type_Eligible_Counterparty.controlID">
                                  <Form.Label>01030_Investor_Type_Eligible_Counterparty</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_01030_Investor_Type_Eligible_Counterparty"
                                    value={this.state.x_01030_Investor_Type_Eligible_Counterparty}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-02010_Basic_Investor '}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02010_Basic_Investor.controlID">
                                  <Form.Label>02010_Basic_Investor</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02010_Basic_Investor "
                                    value={this.state.x_02010_Basic_Investor}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-02020_Informed_Investor'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02020_Informed_Investor.controlID">
                                  <Form.Label>02020_Informed_Investor</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02020_Informed_Investor"
                                    value={this.state.x_02020_Informed_Investor}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-02030_Advanced_Investor'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02030_Advanced_Investor.controlID">
                                  <Form.Label>02030_Advanced_Investor</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02030_Advanced_Investor"
                                    value={this.state.x_02030_Advanced_Investor}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-02040_Expert_Investor_Germany'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="02040_Expert_Investor_Germany.controlID">
                                  <Form.Label>02040_Expert_Investor_Germany</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_02040_Expert_Investor_Germany"
                                    value={this.state.x_02040_Expert_Investor_Germany}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary" type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    ) : null
                  }
                  {
                    this.state.eventKey === 'Risk' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'Risk')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03010_Compatible_With_Clients_Who_Can_Not_Bear_Capital_Loss'}
                                  >
                                    Investor can bear no loss of capital. Minor losses especially due to costs possible. Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group
                                  controlId="03010_Compatible_With_Clients_Who_Can_Not_Bear_Capital_Loss.controlID"
                                >
                                  <Form.Label>
                                    03010_Compatible_With_Clients_Who_Can_Not_Bear_Capital_Loss
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03010_Compatible_With_Clients_Who_Can_Not_Bear_Capital_Loss"
                                    value={this.state.x_03010_Compatible_With_Clients_Who_Can_Not_Bear_Capital_Loss}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03020_Compatible_With_Clients_Who_Can_Bear_Limited_Capital_Loss'}
                                  >
                                    Investor seeking to preserve capital or can bear losses limited to a level specified by the product. Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03020_Limited_Capital_Loss.controlID">
                                  <Form.Label>03020_Compatible_With_Clients_Who_Can_Bear_Limited_Capital_Loss</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03020_Compatible_With_Clients_Who_Can_Bear_Limited_Capital_Loss"
                                    value={this.state.x_03020_Compatible_With_Clients_Who_Can_Bear_Limited_Capital_Loss}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03030_Limited_Capital_Loss_Level'}
                                  >
                                    Loss up to XX%
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03030_Limited_Capital_Loss_Level.controlID">
                                  <Form.Label>03030_Limited_Capital_Loss_Level</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03030_Limited_Capital_Loss_Level"
                                    value={this.state.x_03030_Limited_Capital_Loss_Level}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03040_No_Capital_Guarantee'}
                                  >
                                    No Capital Guarantee nor protection. 100% capital at risk. Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03040_Compatible_With_Clients_Who_Do_Not_Need_Capital_Guarantee.controlID">
                                  <Form.Label>03040_Compatible_With_Clients_Who_Do_Not_Need_Capital_Guarantee</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03040_Compatible_With_Clients_Who_Do_Not_Need_Capital_Guarantee"
                                    value={this.state.x_03040_Compatible_With_Clients_Who_Do_Not_Need_Capital_Guarantee}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-03050_Compatible_With_Clients_Who_Can_Bear_Loss_Beyond_Capital'}
                                  >
                                    Loss Beyond the Capital. Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="03050_Compatible_With_Clients_Who_Can_Bear_Loss_Beyond_Capital.controlID">
                                  <Form.Label>03050_Compatible_With_Clients_Who_Can_Bear_Loss_Beyond_Capital</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_03050_Compatible_With_Clients_Who_Can_Bear_Loss_Beyond_Capital"
                                    value={this.state.x_03050_Compatible_With_Clients_Who_Can_Bear_Loss_Beyond_Capital}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                            </Col>
                            <Col>

                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-04010_Risk_Tolerance_PRIIPS_Methodology'}
                                  >
                                    SRI
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04010_Risk_Tolerance_PRIIPS_Methodology.controlID">
                                  <Form.Label>04010_Risk_Tolerance_PRIIPS_Methodology</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04010_Risk_Tolerance_PRIIPS_Methodology"
                                    value={this.state.x_04010_Risk_Tolerance_PRIIPS_Methodology}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1 - 7"
                                    pattern="[1-7]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: 1, 2, 3, 4, 5, 6, 7.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-04020_Risk_Tolerance_UCITS_Methodology'}
                                  >
                                    SRRI
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04020_Risk_Tolerance_UCITS_Methodology.controlID">
                                  <Form.Label>04020_Risk_Tolerance_UCITS_Methodology</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04020_Risk_Tolerance_UCITS_Methodology"
                                    value={this.state.x_04020_Risk_Tolerance_UCITS_Methodology}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1 - 7"
                                    pattern="[1-7]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: 1, 2, 3, 4, 5, 6, 7.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-04030_Risk_Tolerance_Internal_Methodology_For_Non_PRIIPS_And_Non_UCITS'}
                                  >
                                    Low/medium/high
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04030_Risk_Tolerance_Internal_Methodology_For_Non_PRIIPS_And_Non_UCITS.controlID">
                                  <Form.Label>04030_Risk_Tolerance_Internal_Methodology_For_Non_PRIIPS_and_Non_UCITS</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04030_Risk_Tolerance_Internal_Methodology_For_Non_PRIIPS_And_Non_UCITS"
                                    value={this.state.x_04030_Risk_Tolerance_Internal_Methodology_For_Non_PRIIPS_And_Non_UCITS}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="L / M / H"
                                    pattern="(L|M|H)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be of the following values: 1, 2, 3, 4, 5, 6.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-04040_Risk_Tolerance_For_Non_PRIIPS_and_Non_UCITS_Spain'}
                                  >
                                    Spanish SRI
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04040_Risk_Tolerance_For_Non_PRIIPS_And_Non_UCITS_Spain.controlID">
                                  <Form.Label>04040_Risk_Tolerance_For_Non_PRIIPS_And_Non_UCITS_Spain</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04040_Risk_Tolerance_For_Non_PRIIPS_And_Non_UCITS_Spain"
                                    value={this.state.x_04040_Risk_Tolerance_For_Non_PRIIPS_And_Non_UCITS_Spain}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="1 - 6"
                                    pattern="[1-6]{1}"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be of the following values: 1, 2, 3, 4, 5, 6.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-04050_Not_For_Investors_With_The_Lowest_Risk_Tolerance_Germany'}
                                  >
                                    Yes or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="04050_Not_For_Investors_With_The_Lowest_Risk_Tolerance_Germany.controlID">
                                  <Form.Label>04050_Not_For_Investors_With_The_Lowest_Risk_Tolerance_Germany</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_04050_Not_For_Investors_With_The_Lowest_Risk_Tolerance_Germany"
                                    value={this.state.x_04050_Not_For_Investors_With_The_Lowest_Risk_Tolerance_Germany}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / Neutral"
                                    pattern="(Y|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    ) : null
                  }
                  {
                    this.state.eventKey === 'Objectives' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'Objectives')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05010_Return_Profile_Client_Looking_For_Preservation'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05010_Return_Profile_Client_Looking_For_Preservation.controlID">
                                  <Form.Label>05010_Return_Profile_Client_Looking_For_Preservation</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05010_Return_Profile_Client_Looking_For_Preservation"
                                    value={this.state.x_05010_Return_Profile_Client_Looking_For_Preservation}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05020_Return_Profile_Client_Looking_For_Capital_Growth'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05020_Return_Profile_Client_Looking_For_Capital_Growth.controlID">
                                  <Form.Label>05020_Return_Profile_Client_Looking_For_Capital_Growth</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05020_Return_Profile_Client_Looking_For_Capital_Growth"
                                    value={this.state.x_05020_Return_Profile_Client_Looking_For_Capital_Growth}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05030_Return_Profile_Client_Looking_For_Income'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05030_Return_Profile_Client_Looking_For_Income.controlID">
                                  <Form.Label>05030_Return_Profile_Client_Looking_For_Income</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05030_Return_Profile_Client_Looking_For_Income"
                                    value={this.state.x_05030_Return_Profile_Client_Looking_For_Income}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05040_Return_Profile_Hedging'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05040_Return_Profile_Hedging.controlID">
                                  <Form.Label>05040_Return_Profile_Hedging</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05040_Return_Profile_Hedging"
                                    value={this.state.x_05040_Return_Profile_Hedging}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"

                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05050_Option_Or_Leveraged_Return_Profile'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05050_Option_Or_Leveraged_Return_Profile.controlID">
                                  <Form.Label>05050_Option_Or_Leveraged_Return_Profile</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05050_Option_Or_Leveraged_Return_Profile"
                                    value={this.state.x_05050_Option_Or_Leveraged_Return_Profile}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05070_Return_Profile_Pension_Scheme_Germany'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05070_Return_Profile_Pension_Scheme_Germany.controlID">
                                  <Form.Label>05070_Return_Profile_Pension_Scheme_Germany</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05070_Return_Profile_Pension_Scheme_Germany"
                                    value={this.state.x_05070_Return_Profile_Pension_Scheme_Germany}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-05080_Minimum_Recommended_Holding_Period'}
                                  >
                                    <span>RHP in years or Very Short Term (Less Than 1Y) or Short term (Less Than 3Y) or Medium term (Less Than 5Y) or Long term (Greater Than 5Y) or Neutral</span>
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05080_Minimum_Recommended_Holding_Period.controlID">
                                  <Form.Label>05080_Minimum_Recommended_Holding_Period</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05080_Minimum_Recommended_Holding_Period"
                                    value={this.state.x_05080_Minimum_Recommended_Holding_Period}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must either be a decimal value or one of the values V, S, M, L or Neutral
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-05105_Intended_Compatible_With_Clients_Having_ESG_Preferences'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05105_Intended_Compatible_With_Clients_Having_ESG_Preferences.controlID" hidden={this.state.emtVersion === '3.1' ? true : false}>
                                  <Form.Label>05105_Intended_Compatible_With_Clients_Having_ESG_Preferences</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05105_Intended_Compatible_With_Clients_Having_ESG_Preferences"
                                    value={this.state.x_05105_Intended_Compatible_With_Clients_Having_ESG_Preferences}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-05105_Intended_Compatible_With_Clients_Having_Sustainability_Preferences'}
                                  >
                                    Yes or No or Neutral
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05105_Intended_Compatible_With_Clients_Having_Sustainability_Preferences.controlID" hidden={this.state.emtVersion === '3.1' ? false : true}>
                                  <Form.Label>05105_Intended_Compatible_With_Clients_Having_Sustainability_Preferences</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05105_Intended_Compatible_With_Clients_Having_Sustainability_Preferences"
                                    value={this.state.x_05105_Intended_Compatible_With_Clients_Having_Sustainability_Preferences}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / Neutral"
                                    pattern="(Y|N|Neutral)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y,N or Neutral.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-05115_Other_Specific_Investment_Need'}
                                  >
                                    Yes or No or (Green investment, Ethical investment, Islamic banking, ESG, Other)

                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="05115_Other_Specific_Investment_Need.controlID">
                                  <Form.Label>05115_Other_Specific_Investment_Need</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_05115_Other_Specific_Investment_Need"
                                    value={this.state.x_05115_Other_Specific_Investment_Need}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="Y / N / G / E / I / S / O"
                                    pattern="(Y|N|G|R|I|S|O)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: Y,N,G,E,I,S,O
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-06010_Execution_Only'}
                                  >
                                    Retail or Professional or Both or Neither
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06010_Execution_Only.controlID">
                                  <Form.Label>06010_Execution_Only</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06010_Execution_Only"
                                    value={this.state.x_06010_Execution_Only}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="R / P / B / N"
                                    pattern="(R|P|B|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: R,P,B,N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-06020_Execution_With_Appropriateness_Test_Or_Non_Advised_Services'}
                                  >
                                    Retail or Professional or Both or Neither
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06020_Execution_With_Appropriateness_Test_Or_Non_Advised_Services.controlID">
                                  <Form.Label>06020_Execution_With_Appropriateness_Test_Or_Non_Advised_Services</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06020_Execution_With_Appropriateness_Test_Or_Non_Advised_Services"
                                    value={this.state.x_06020_Execution_With_Appropriateness_Test_Or_Non_Advised_Services}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="R / P / B / N"
                                    pattern="(R|P|B|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: R,P,B,N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-06030_Investment_Advice'}
                                  >
                                    Retail or Professional or Both or Neither
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06030_Investment_Advice.controlID">
                                  <Form.Label>06030_Investment_Advice</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06030_Investment_Advice"
                                    value={this.state.x_06030_Investment_Advice}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="R / P / B / N"
                                    pattern="(R|P|B|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: R,P,B,N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-06040_Portfolio_Management'}
                                  >
                                    Retail or Professional or Both or Neither
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="06040_Portfolio_Management.controlID">
                                  <Form.Label>06040_Portfolio_Management</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_06040_Portfolio_Management"
                                    value={this.state.x_06040_Portfolio_Management}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="R / P / B / N"
                                    pattern="(R|P|B|N)"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be one of the following values: R,P,B,N.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>

                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                        backgroundColor: '#6F08CD',
                                        border: '1px hidden',
                                        borderRadius: '100px',
                                        letterSpacing: '1.25px',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        minHeight: '24px',
                                        padding: '0.5rem 1.2rem',
                                      }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>

                      </Col>
                    ) : null
                  }
                  {
                    this.state.eventKey === 'CostsExAnte' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'CostsExAnte')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07020_Gross_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Non_Acquired'}
                                  >
                                    Maximum not acquired to the fund (ETF are excluded). Expressed as a % of the amount to be invested.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07020_Gross_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Non_Acquired.controlID">
                                  <Form.Label>07020_Gross_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Non_Acquired</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00060_Financial_Instrument_Product_Type === 'S' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07020_Gross_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Non_Acquired"
                                    value={this.state.x_07020_Gross_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Non_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07025_Net_One_off_Cost_Structured_Products_Entry_Cost_Non_Acquired'}
                                  >
                                    Maximum not acquired to the fund (ETF are excluded). Expressed as a % of the amount to be invested.
                                  </Popover>
                                )}
                              >
                                <Form.Group
                                  controlId="07025_Net_One_off_Cost_Structured_Products_Entry_Cost_Non_Acquired.controlID"
                                >
                                  <Form.Label>07025_Net_One_off_Cost_Structured_Products_Entry_Cost_Non_Acquired</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00060_Financial_Instrument_Product_Type === 'S' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07025_Net_One_off_Cost_Structured_Products_Entry_Cost_Non_Acquired"
                                    value={this.state.x_07025_Net_One_off_Cost_Structured_Products_Entry_Cost_Non_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required for Structured products and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07030_One-off_cost_Financial_Instrument_maximum_entry_cost_fixed_amount_Italy'}
                                  >
                                    Maximum fixed amount per subscription, not incorporated. Flat fee defined by the manufacturer
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07030_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Fixed_Amount_Italy.controlID">
                                  <Form.Label>
                                    07030_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Fixed_Amount_Italy
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07030_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Fixed_Amount_Italy"
                                    value={this.state.x_07030_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Fixed_Amount_Italy}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07040_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Acquired'}
                                  >
                                    Subscription fees acquired to the fund. Expressed as a % of the amount to be invested.
                                  </Popover>
                                )}
                              >
                                <Form.Group
                                  controlId="07040_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Acquired.controlID"
                                >
                                  <Form.Label>07040_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Acquired</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07040_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Acquired"
                                    value={this.state.x_07040_One_off_Cost_Financial_Instrument_Maximum_Entry_Cost_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07050_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Non_Acquired'}
                                  >
                                    Maximum not acquired to the fund (ETF are excluded). Expressed as a % of the NAV.
                                  </Popover>
                                )}
                              >
                                <Form.Group
                                  controlId="07050_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Non_Acquired.controlID"
                                >
                                  <Form.Label>07050_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Non_Acquired</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07050_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Non_Acquired"
                                    value={this.state.x_07050_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Non_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07060_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Fixed_Amount_Italy'}
                                  >
                                    Maximum fixed amount per redemption, not incorporated. Flat fee defined by the manufacturer
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07060_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Fixed_Amount_Italy.controlID">
                                  <Form.Label>07060_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Fixed_Amount_Italy</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07060_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Fixed_Amount_Italy"
                                    value={this.state.x_07060_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Fixed_Amount_Italy}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07070_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Acquired'}
                                  >
                                    Maximum (ETF are excluded). Subscription fees acquired to the fund Expressed as a % of the NAV
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07070_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Acquired.controlID">
                                  <Form.Label>07070_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Acquired</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07070_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Acquired"
                                    value={this.state.x_07070_One_off_Costs_Financial_Instrument_Maximum_Exit_Cost_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-07080_One_off_Costs_Financial_Instrument_Typical_Exit_Cost'}
                                  >
                                    Current exit cost linked to the RHP or Time to Maturity or 1Y (V) or 3Y(S) or 5Y (M L) (the value of 05080_Time_Horizon)
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07080_One_off_Costs_Financial_Instrument_Typical_Exit_Cost.controlID">
                                  <Form.Label>07080_One_off_Costs_Financial_Instrument_Typical_Exit_Cost</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07080_One_off_Costs_Financial_Instrument_Typical_Exit_Cost"
                                    value={this.state.x_07080_One_off_Costs_Financial_Instrument_Typical_Exit_Cost}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07090_One_off_Cost_Financial_Instrument_Exit_Cost_Structured_Products_Prior_RHP'}
                                  >
                                    Fixed amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07090_One_off_Cost_Financial_Instrument_Exit_Cost_Structured_Products_Prior_RHP.controlID">
                                  <Form.Label>07090_One_off_Cost_Financial_Instrument_Exit_Cost_Structured_Products_Prior_RHP</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07090_One_off_Cost_Financial_Instrument_Exit_Cost_Structured_Products_Prior_RHP"
                                    value={this.state.x_07090_One_off_Cost_Financial_Instrument_Exit_Cost_Structured_Products_Prior_RHP}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07100_Financial_Instrument_Ongoing_costs'}
                                  >
                                    Expressed as a% of NAV of the Financial Product / per annum. Ex ante
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07100_Financial_Instrument_Gross_Ongoing_Costs.controlID">
                                  <Form.Label>07100_Financial_Instrument_Gross_Ongoing_Costs</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07100_Financial_Instrument_Gross_Ongoing_Costs"
                                    value={this.state.x_07100_Financial_Instrument_Gross_Ongoing_Costs}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>


                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07105_Financial_Instrument_Borrowing_Costs_Ex_Ante_UK'}
                                  >
                                    Expressed as a% of NAV of the Financial Product / per annum. Ex ante
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07105_Financial_Instrument_Borrowing_Costs_Ex_Ante_UK.controlID">
                                  <Form.Label>07105_Financial_Instrument_Borrowing_Costs_Ex_Ante_UK</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07105_Financial_Instrument_Borrowing_Costs_Ex_Ante_UK"
                                    value={this.state.x_07105_Financial_Instrument_Borrowing_Costs_Ex_Ante_UK}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07110_Financial_Instrument_Management_fee'}
                                  >
                                    Expressed as a % of NAV of the Financial Product / per annum. Ex Ante.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07110_Financial_Instrument_Management_fee.controlID">
                                  <Form.Label>07110_Financial_Instrument_Management_Fee</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00060_Financial_Instrument_Product_Type !== null && this.state.x_00060_Financial_Instrument_Product_Type !== 'S' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07110_Financial_Instrument_Management_Fee"
                                    value={this.state.x_07110_Financial_Instrument_Management_Fee}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required for Funds and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07120_Financial_Instrument_Distribution_Fee'}
                                  >
                                    Expressed as a % of NAV of the Financial Product / per annum. Ex Ante.
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07120_Financial_Instrument_Distribution_Fee.controlID">
                                  <Form.Label>07120_Financial_Instrument_Distribution_fee</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07120_Financial_Instrument_Distribution_Fee"
                                    value={this.state.x_07120_Financial_Instrument_Distribution_Fee}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value and should not be populated for Structured securities.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-07130_Financial_Instrument_Transaction_Costs_Ex_Ante'}
                                  >
                                    Expressed as a % of NAV of the Financial Product . Ex Ante
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07130_Financial_Instrument_Transaction_Costs_Ex_Ante.controlID">
                                  <Form.Label>07130_Financial_Instrument_Transaction_Costs_Ex_Ante</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07130_Financial_Instrument_Transaction_Costs_Ex_Ante"
                                    value={this.state.x_07130_Financial_Instrument_Transaction_Costs_Ex_Ante}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required for Funds and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-07140_Financial_Instrument_Incidental_Costs_Ex_Ante'}
                                  >
                                    Expressed as a % of NAV of the Financial Product. Includes performance fees and others costs Ex ante
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="07140_Financial_Instrument_Incidental_Costs_Ex_Ante.controlID">
                                  <Form.Label>07140_Financial_Instrument_Incidental_Costs_Ex_Ante</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_07140_Financial_Instrument_Incidental_Costs_Ex_Ante"
                                    value={this.state.x_07140_Financial_Instrument_Incidental_Costs_Ex_Ante}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">

                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                            </Col>

                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    ) : null
                  }
                  {
                    this.state.eventKey === 'CostsExPost' ? (
                      <Col>
                        <Form
                          noValidate
                          validated={this.state.validated}
                          onSubmit={e => this.handleSubmit(e, 'CostsExPost')}
                        >
                          <Row>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-08010_Gross_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post'}>
                                    Fixed Amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08010_Gross_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post.controlID">
                                  <Form.Label>08010_Gross_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08010_Gross_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post"
                                    value={this.state.x_08010_Gross_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover id={'popover-08015_Net_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post'}>
                                    Fixed Amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08015_Net_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post.controlID">
                                  <Form.Label>08015_Net_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08015_Net_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post"
                                    value={this.state.x_08015_Net_One_off_Cost_Structured_Securities_Entry_Cost_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>


                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08020_One_off_Costs_Structured_Securities_Exit_Cost_Ex_Post'}
                                  >
                                    Fixed amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08020_One_off_Costs_Structured_Securities_Exit_Cost_Ex_Post.controlID">
                                  <Form.Label>08020_One_off_Costs_Structured_Securities_Exit_Cost_Ex_Post</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08020_One_off_Costs_Structured_Securities_Exit_Cost_Ex_Post"
                                    value={this.state.x_08020_One_off_Costs_Structured_Securities_Exit_Cost_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08025_One_off_Cost_Financial_Instrument_Entry_Cost_Acquired'}
                                  >
                                    Fixed amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08025_One_off_Cost_Financial_Instrument_Entry_Cost_Acquired.controlID">
                                  <Form.Label>08025_One_off_Cost_Financial_Instrument_Entry_Cost_Acquired</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08025_One_off_Cost_Financial_Instrument_Entry_Cost_Acquired"
                                    value={this.state.x_08025_One_off_Cost_Financial_Instrument_Entry_Cost_Acquired}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>


                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08030_Financial_Instrument_Ongoing_costs_ex_post'}
                                  >
                                    Definition tbd as a % of NAV of the Financial Product / per annum. Occured costs over one year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08030_Financial_Instrument_Ongoing_Costs_Ex_Post.controlID">
                                  <Form.Label>08030_Financial_Instrument_Ongoing_Costs_Ex_Post</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08030_Financial_Instrument_Ongoing_Costs_Ex_Post"
                                    value={this.state.x_08030_Financial_Instrument_Ongoing_Costs_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08040_Structured_Securities_Ongoing_Costs_Ex_Post_Accumulated'}
                                  >
                                    Sum of each daily Recurring Product Costs
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08040_Structured_Securities_Ongoing_Costs_Ex_Post_Accumulated.controlID">
                                  <Form.Label>08040_Structured_Securities_Ongoing_Costs_Ex_Post_Accumulated</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08040_Structured_Securities_Ongoing_Costs_Ex_Post_Accumulated"
                                    value={this.state.x_08040_Structured_Securities_Ongoing_Costs_Ex_Post_Accumulated}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Structured securities and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08045_Financial_Instrument_Borrowing_Costs_Ex_Post_UK'}
                                  >
                                    Sum of each daily Product Borrowing Costs
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08045_Financial_Instrument_Borrowing_Costs_Ex_Post_UK.controlID">
                                  <Form.Label>08045_Financial_Instrument_Borrowing_Costs_Ex_Post_UK</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08045_Financial_Instrument_Borrowing_Costs_Ex_Post_UK"
                                    value={this.state.x_08045_Financial_Instrument_Borrowing_Costs_Ex_Post_UK}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is only used for Product Borrowing Costs and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08050_Financial_Instrument_Management_Fee_Ex_Post'}
                                  >
                                    Definition tbd as a % of NAV of the Financial Product / per annum. Occured costs over one year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08050_Financial_Instrument_Management_Fee_Ex_Post.controlID">
                                  <Form.Label>08050_Financial_Instrument_Management_Fee_Ex_Post</Form.Label>
                                  <Form.Control
                                    required={this.state.x_00060_Financial_Instrument_Product_Type !== null && this.state.x_00060_Financial_Instrument_Product_Type !== 'S' ? true : false}
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08050_Financial_Instrument_Management_Fee_Ex_Post"
                                    value={this.state.x_08050_Financial_Instrument_Management_Fee_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required for Funds and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08060_Financial_Instrument_Distribution_Fee_Ex_Post'}
                                  >
                                    Definition tbd as a % of NAV of the Financial Product / per annum. Occured costs over one year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08060_Financial_Instrument_Distribution_Fee_Ex_Post.controlID">
                                  <Form.Label>08060_Financial_Instrument_Distribution_Fee_Ex_Post</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08060_Financial_Instrument_Distribution_Fee_Ex_Post"
                                    value={this.state.x_08060_Financial_Instrument_Distribution_Fee_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={(
                                  <Popover
                                    id={'popover-08070_Financial_Instrument_Transaction_Costs_Ex_Post'}
                                  >
                                    Definition tbd as a % of NAV of the Financial Product .Occured costs over one year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08070_Financial_Instrument_Transaction_Costs_Ex_Post.controlID">
                                  <Form.Label>08070_Financial_Instrument_Transaction_Costs_Ex_Post</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08070_Financial_Instrument_Transaction_Costs_Ex_Post"
                                    value={this.state.x_08070_Financial_Instrument_Transaction_Costs_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                            <Col>
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={(
                                  <Popover
                                    id={'popover-08080_Financial_Instrument_Incidental_Costs_Ex_Post'}
                                  >
                                    Definition tbd as a % of NAV of the Financial Product. Occured costs over one year
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08080_Financial_Instrument_Incidental_Costs_Ex_Post.controlID">
                                  <Form.Label>08080_Financial_Instrument_Incidental_Costs_Ex_Post</Form.Label>
                                  <Form.Control
                                    required
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08080_Financial_Instrument_Incidental_Costs_Ex_Post"
                                    value={this.state.x_08080_Financial_Instrument_Incidental_Costs_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="decimal (0.00)"
                                    pattern="^[+-]?((\d+(\.\d*)?)|(\.\d+))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field is required and must be a decimal value.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-08090_Beginning_Of_Reference_Period'}
                                  >
                                    Date of beginning of reference period
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08090_Beginning_Of_Reference_Period.controlID">
                                  <Form.Label>08090_Beginning_Of_Reference_Period</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08090_Beginning_Of_Reference_Period"
                                    value={this.state.x_08090_Beginning_Of_Reference_Period}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="YYYY-MM-DD"
                                    pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a date formatted as YYYY-MM-DD.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-08100_End_Of_Reference_Period'}
                                  >
                                    Date of end of reference period
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08100_End_Of_Reference_Period.controlID">
                                  <Form.Label>08100_End_Of_Reference_Period</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08100_End_Of_Reference_Period"
                                    value={this.state.x_08100_End_Of_Reference_Period}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder="YYYY-MM-DD"
                                    pattern="^[1-2]{1}[0-9]{3}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    This field must be a date formatted as YYYY-MM-DD.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-08110_Structured_Securities_Reference_Price_Ex_Post'}
                                  >
                                    Structured Securities Reference Price
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08110_Structured_Securities_Reference_Price_Ex_Post.controlID">
                                  <Form.Label>08110_Structured_Securities_Reference_Price_Ex_Post</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08110_Structured_Securities_Reference_Price_Ex_Post"
                                    value={this.state.x_08110_Structured_Securities_Reference_Price_Ex_Post}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-08120_Structured_Securities_Notional_Reference_Amount'}
                                  >
                                    Structured Securities Notional Reference Amount
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="08120_Structured_Securities_Notional_Reference_Amount.controlID">
                                  <Form.Label>08120_Structured_Securities_Notional_Reference_Amount</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_08120_Structured_Securities_Notional_Reference_Amount"
                                    value={this.state.x_08120_Structured_Securities_Notional_Reference_Amount}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-09000_ESG_Category_For_German_Market'}
                                  >
                                    ESG Category For German Market
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="09000_ESG_Category_For_German_Market.controlID" hidden={this.state.emtVersion === '3.1' ? false : true}>
                                  <Form.Label>09000_ESG_Category_For_German_Market</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_09000_ESG_Category_For_German_Market"
                                    value={this.state.x_09000_ESG_Category_For_German_Market}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-09010_ESG_Focus'}
                                  >
                                    ESG Focus
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="09010_ESG_Focus.controlID" hidden={this.state.emtVersion === '3.1' ? false : true}>
                                  <Form.Label>09010_ESG_Focus</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_09010_ESG_Focus"
                                    value={this.state.x_09010_ESG_Focus}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-09020_ESG_Label_Or_Standard'}
                                  >
                                    ESG Label or Standard
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="09020_ESG_Label_Or_Standard.controlID" hidden={this.state.emtVersion === '3.1' ? false : true}>
                                  <Form.Label>09020_ESG_Label_Or_Standard</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_09020_ESG_Label_Or_Standard"
                                    value={this.state.x_09020_ESG_Label_Or_Standard}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>

                              <OverlayTrigger
                                trigger="click"
                                placement="bottom"
                                overlay={(
                                  <Popover
                                    id={'popover-10020_AMF_Doctrine'}
                                  >
                                    AMF Doctrine
                                  </Popover>
                                )}
                              >
                                <Form.Group controlId="10020_AMF_Doctrine.controlID" hidden={this.state.emtVersion === '3.1' ? false : true}>
                                  <Form.Label>10020_AMF_Doctrine</Form.Label>
                                  <Form.Control
                                    type="text"
                                    style={{ backgroundColor: this.state.action_type === 'Edit' ? '#fff' : '#F8F8FF' }}
                                    name="x_10020_AMF_Doctrine"
                                    value={this.state.x_10020_AMF_Doctrine}
                                    onChange={this.handleInputChange}
                                    disabled={this.state.action_type === 'Edit' ? false : true}
                                    placeholder=""
                                  />
                                  <Form.Control.Feedback type="invalid">
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <ButtonToolbar>
                                {
                                  this.state.action_type === 'Edit' ? (
                                    <Button
                                      style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                      variant="primary"
                                      type="submit"
                                    >
                                      Save
                                    </Button>
                                  ) : null
                                }
                                <Button
                                  style={{
                                    backgroundColor: '#6F08CD',
                                    border: '1px hidden',
                                    borderRadius: '100px',
                                    letterSpacing: '1.25px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    minHeight: '24px',
                                    padding: '0.5rem 1.2rem',
                                  }}
                                  variant="secondary"
                                  onClick={() => { this.setState({ redirect: true }); }}
                                >
                                  Cancel
                                </Button>
                              </ButtonToolbar>
                            </Col>
                          </Row>
                        </Form>
                      </Col>
                    ) : null
                  }
                </Row>
              </>
            }
          </RegEditBody>
        </RegEditView>
      ));
  }
}

EMTv4editor.contextType = AppContext;

export default EMTv4editor;
